<template>
    <v-container fluid>
      <v-dialog
              v-model="showloading"
              hide-overlay
              persistent
              width="300"
      >
        <v-card
                color="secondary"
                dark
        >
          <v-card-text>
            <v-progress-linear
                    indeterminate
                    color="white"
                    class="ma-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-layout row >
        <v-subheader>Estimates</v-subheader>
        <v-spacer></v-spacer>

        <v-btn icon @click="loadEstimates(0)"><v-icon color="grey darken-3">refresh</v-icon></v-btn>

        <v-icon @click="changeEstimateStatus()" :class="[errorStatus? 'orange--text': 'grey--text']">error</v-icon>

        <v-btn icon :disabled="currentPage <= 0" @click="loadEstimates(-1)"><v-icon color="grey darken-3">keyboard_arrow_left</v-icon></v-btn>
        <v-subheader>
          <small>{{ currentPageDate() }}</small>
        </v-subheader>
        <v-btn icon :disabled="errorStatus" @click="loadEstimates(1)"><v-icon color="grey darken-3">keyboard_arrow_right</v-icon></v-btn>
      </v-layout>

      <v-layout row class="grey lighten-2 pa-2">
        <v-flex class="xs1 ml-3">
          #
          <v-icon>check_circle</v-icon>
          <v-icon class="ml-4 pl-1">loop</v-icon>
        </v-flex>
        <v-flex class="xs1 ml-1 pl-2">
          <h4 class="subheading">status</h4>
        </v-flex>
        <v-flex class="xs1 ">
          <h4 class="subheading">shopify#</h4>
        </v-flex>
        <v-flex class="xs1 pl-2">
          <h4 class="subheading">ns#</h4>
        </v-flex>
        <v-flex class="xs1 ">
          <h4 class="subheading">date</h4>
        </v-flex>
        <v-flex class="xs1">
          <h4 class="subheading">message</h4>
        </v-flex>
      </v-layout>
      <div class="scrolly">
        <v-list subheader>
          <v-list-tile
                  class="listitem"
                  v-for="(item, i) in items"
                  :key="i"
                  avatar
          >
            <small>{{i < 9 ? "0" + (i + 1) : (i + 1)}}</small>
            <v-list-tile-avatar>
              <v-icon @click="markAsResolved(i)" v-if="item.estimate_status !== 'success'" :class="[item.estimate_status === 'failed'? 'red--text': 'orange--text']">error</v-icon>
              <v-icon v-else color="blue">check_circle</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-avatar>
              <v-btn icon @click="retryEstimate(i)" :disabled="item.estimate_status === 'success'"><v-icon>loop</v-icon></v-btn>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-container fluid class="pl-0">
                <v-layout row class="">
                  <v-flex class="xs1  ml-1">
                    <h4 :class="[item.estimate_status === 'success'? 'blue--text' : (item.estimate_status === 'pending'? 'grey--text' : 'red--text'), 'text--darken-3', 'subheading']">
                      <strong>{{item.estimate_status.toUpperCase()}}</strong>
                    </h4>
                  </v-flex>
                  <v-flex class="xs1 ml-2">
                    <small>
                      <a :href="storeUrl"
                         target="_blank">
                        {{item.draft_order_id?item.draft_order_id.substring(25):'undefined'}}
                      </a>
                    </small>
                  </v-flex>
                  <v-flex class="xs1 ml-4">
                    <small>
                      <a :href="'https://system.na3.netsuite.com/app/accounting/transactions/estimate.nl?id=' + item.estimate_id"
                         target="_blank">
                        {{item.estimate_id}}
                      </a>
                    </small>
                  </v-flex>
                  <v-flex class="xs1">
                    <small>{{new Date(item.createdAt).toLocaleDateString('en-US')}}</small>
                  </v-flex>
                  <v-flex class="ml-3">
                    <small>{{item.store_name + " | " + (item.estimate_error || '')}}</small>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </div>
    </v-container>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.listitem {
  border-bottom: lightgrey solid 1px;
}
.scrolly {
  overflow: auto;
  height: 74vh;
}
</style>

<script >
  //const API_URL = 'http://192.168.1.117:3000/graphql';
  const API_URL = '/graphql';

  export default{
    name: "EstimateStatusList",
    data() {
      return {
        showloading: false,
        items: [],
        storeUrl: 'https://ryonet.myshopify.com',
        currentPage: 0,
        errorStatus: false
      }
    },
    created() {
      this.loadEstimates(0);
    },
    methods: {
      changeEstimateStatus() {
        this.errorStatus = !this.errorStatus;
        this.loadEstimates(0);
      },
      currentPageDate() {
        let newDate = new Date();
        newDate.setDate( newDate.getDate() - this.currentPage);
        return newDate.toDateString();
      },
      markAsResolved(i) {
        this.showloading = true;
        if(confirm("Mark As Resolved?")){
          // Call API to Change status to resolved
          fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({"query": `mutation{
                      resolveEstimate(input: {estimate_id: \"${this.items[i].estimate_id}\"}){
                        estimate_id
                      }
                    }`
            }),
            headers: {
              'content-type': 'application/json'
            }
          }).then(response => response.json()).then(result => {
            this.loadEstimates(0);
          }).catch(e => { this.showloading = false; console.log("ERROR: " + e); });
        }
      },
      retryEstimate(i) {
        this.showloading = true;
        fetch(API_URL, {
          method: 'POST',
          body: JSON.stringify({"query": `mutation{
                      estimateRerun(input: {estimate_id: \"${this.items[i].estimate_id}\"}){
                        estimate_id
                      }
                    }`
          }),
          headers: {
            'content-type': 'application/json'
          }
        }).then(response => response.json()).then(result => {
          this.showloading = false;
          this.loadEstimates(0);
        }).catch(e => { this.showloading = false; alert("ERROR: " + e); });
      },
      loadEstimates(page){
        this.currentPage = page === 0 ? page : this.currentPage + page;
        this.showloading = true;
        fetch(API_URL, {
          method: 'POST',
          body: JSON.stringify({"query": `{
                      estimatesByDate(page: "${this.currentPage}", error: "${this.errorStatus}"){
                        estimate_id
                        draft_order_id
                        estimate_status
                        estimate_error
                        store_name
                        createdAt
                      }
                    }`
          }),
          headers: {
            'content-type': 'application/json'
          }
        }).then(response => response.json()).then(result => {
          let resultItems = result.data.estimatesByDate;
          resultItems.sort(function(a, b){return new Date(b.createdAt) - new Date(a.createdAt)});
          this.showloading = false;
          this.items = resultItems;
          console.log(result);
          try {
            console.log(JSON.stringify(result));
          } catch (e) { console.log(e); }
        }).catch(e => { this.showloading = false; });
      },
    }
  }

</script>